import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "errorpage",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }

import {onMounted} from "vue";
import {$t} from "@/utilities/i18n/config";
import {useGlobalStore} from "@/stores/GlobalStore";



export default /*@__PURE__*/_defineComponent({
  __name: 'DisdiExit',
  setup(__props) {

const globalStore = useGlobalStore();

onMounted(()=>{
  globalStore.resetState();
  globalStore.user = null;
  globalStore.token = "";
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref($t)("disdi.exit.byeText")), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref($t)("disdi.exit.byeSubText")), 1)
    ])
  ]))
}
}

})